/*
 * Calls the callback "fn" at most one time every "wait" miliseconds.
 */
export function throttle(wait, fn) {
	let blocked = false,
		waiting = false;

	return () => {
		if (blocked) {
			waiting = true;
			return;
		}

		blocked = true;
		setTimeout(() => {
			blocked = false;
			if (waiting) {
				fn();
				waiting = false;
			}
		}, wait);

		fn();
	};
}
